import { Form, Input, Select, Switch } from 'antd';
import React from 'react';
import { IdefaultVendor } from './Vendor';

interface VendorRegulatoryInfoCollapsibleProps {
  vendorDetails: IdefaultVendor;
  onChange: (key: string, value: any) => void;
}

type FieldType = {
  fcc_id?: string;
  indoor_rated?: boolean;
  regulatory_certification?: string;
  regulatory_country?: string;
};

const VendorRegulatoryInfoCollapsible: React.FC<VendorRegulatoryInfoCollapsibleProps> = ({ vendorDetails, onChange }) => {
  const handleChange = (key: string, value: any) => {
    onChange(key, value);
  };

  return (
    <Form
      name="basic"
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 24 }}
      initialValues={{
        fcc_id: vendorDetails.fcc_id,
        indoor_rated: vendorDetails.indoor_rated,
        regulatory_certification: vendorDetails.regulatory_certification,
        regulatory_country: vendorDetails.regulatory_country,
      }}
      autoComplete="off">
      <Form.Item<FieldType> label="Regulatory ID" name="fcc_id" rules={[{ required: true, message: 'Please provide Regulatory ID!' }]}>
        <Input onChange={(e) => handleChange('fcc_id', e.target.value)} />
      </Form.Item>
      <Form.Item<FieldType> label="Indoor Rated" name="indoor_rated" rules={[{ required: false }]}>
        <Switch
          checkedChildren="Yes"
          unCheckedChildren="No"
          defaultChecked={vendorDetails.indoor_rated}
          onChange={(e) => handleChange('indoor_rated', e)}
        />
      </Form.Item>
      <Form.Item<FieldType> label="Regulatory Certification" name="regulatory_certification" rules={[{ required: false }]}>
        <Select
          getPopupContainer={(triggerNode) => {
            return triggerNode.parentNode;
          }}
          options={[
            { label: 'FCC', value: 'FCC' },
            { label: 'ISED', value: 'ISED' },
            { label: 'TrustCert', value: 'TrustCert' },
            { label: 'G&M', value: 'G&M' },
            { label: 'IFT', value: 'IFT' },
            { label: 'NOM', value: 'NOM' },
          ]}
          onChange={(value) => handleChange('regulatory_certification', value)}
        />
      </Form.Item>
      <Form.Item<FieldType> label="Regulatory Country" name="regulatory_country" rules={[{ required: false }]}>
        <Select
          getPopupContainer={(triggerNode) => {
            return triggerNode.parentNode;
          }}
          onChange={(value) => handleChange('regulatory_country', value)}
          value={vendorDetails.regulatory_country}
          options={[
            { label: 'United States', value: 'us' },
            { label: 'Canada', value: 'canada' },
            { label: 'Mexico', value: 'mexico' },
          ]}
        />
      </Form.Item>
    </Form>
  );
};

export default VendorRegulatoryInfoCollapsible;
